import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// initial state
export const INITIAL_STATE = {
  fetching: false,
  error: false,
  sorting: false,
  weekSchedules: [],
  daySchedules: [],
  weekMenuOpened: false,
}

// action types
export const INITIALIZE = 'schedule/INITIALIZE'
export const FETCH_WEEK_SCHEDULES = 'schedule/FETCH_WEEK_SCHEDULES'
export const WEEK_SCHEDULES_FETCHED = 'schedule/WEEK_SCHEDULES_FETCHED'
export const WEEK_SCHEDULES_FETCH_ERROR = 'schedule/WEEK_SCHEDULES_FETCH_ERROR'
export const SORT_DAY_SCHEDULES = 'schedule/SORT_DAY_SCHEDULES'
export const DAY_SCHEDULES_SORTED = 'schedule/DAY_SCHEDULES_SORTED'
export const OPEN_WEEK_MENU = 'schedule/OPEN_WEEK_MENU'
export const CLOSE_WEEK_MENU = 'schedule/CLOSE_WEEK_MENU'
export const CLEAR_DAY_SCHEDULES = 'schedule/CLEAR_DAY_SCHEDULES'
export const CLEAR = 'schedule/CLEAR'

// action creators
export const initialize = always({ type: INITIALIZE })

export const fetchWeekSchedules = always({ type: FETCH_WEEK_SCHEDULES })

export const weekSchedulesFetched = weekSchedules => ({
  type: WEEK_SCHEDULES_FETCHED,
  weekSchedules,
})

export const weekSchedulesFetchError = always({ type: WEEK_SCHEDULES_FETCH_ERROR })

// sortDaySchedules :: () -> Action.SORT_DAY_SCHEDULES
export const sortDaySchedules = always({ type: SORT_DAY_SCHEDULES })

export const daySchedulesSorted = daySchedules => ({
  type: DAY_SCHEDULES_SORTED,
  daySchedules,
})

// openWeekMenu :: () -> Action
export const openWeekMenu = always({ type: OPEN_WEEK_MENU })

// closeWeekMenu :: () -> Action
export const closeWeekMenu = always({ type: CLOSE_WEEK_MENU })

export const clearDaySchedules = always({ type: CLEAR_DAY_SCHEDULES })

export const clear = always({ type: CLEAR })

// reducer
export default createReducer(INITIAL_STATE, {
  [FETCH_WEEK_SCHEDULES]: state => ({
    ...state,
    fetching: true,
    error: false,
  }),

  [WEEK_SCHEDULES_FETCHED]: (state, { weekSchedules }) => ({
    ...state,
    fetching: false,
    weekSchedules,
  }),

  [WEEK_SCHEDULES_FETCH_ERROR]: state => ({
    ...state,
    fetching: false,
    error: true,
  }),

  [SORT_DAY_SCHEDULES]: state => ({
    ...state,
    sorting: true,
  }),

  [DAY_SCHEDULES_SORTED]: (state, { daySchedules }) => ({
    ...state,
    sorting: false,
    daySchedules,
  }),

  [OPEN_WEEK_MENU]: state => ({
    ...state,
    weekMenuOpened: true,
  }),

  [CLOSE_WEEK_MENU] : state => ({
    ...state,
    weekMenuOpened: false,
  }),

  [CLEAR_DAY_SCHEDULES]: state => ({
    ...state,
    daySchedules: [],
  }),

  [CLEAR]: always(INITIAL_STATE),
})
